import React, { Component, Fragment } from "react";
import { Row, Col } from "react-bootstrap";

// services
import { RoleService } from "app/_services/RoleService/RoleService";

// custom
import LogHistory from "app/views/custom/components/Logs/LogHistory";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import {
  CONSTANT,
  SITETYPE,
  //   TRAINING_CONSTANT,
  //   INCIDENT_CONSTANT,
  //   WORKPERMIT_CONSTANT,
  USERROLE,
} from "./Constant";
import BackBtn from "app/Components/CommanComponents/BackBtn";

export class ViewRoles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      viewId: this.props.match.params.id ? this.props.match.params.id : "",
      viewData: {},
    };
  }

  componentDidMount() {
    this.viewData();
  }

  /*******************Api Call *******************/

  viewData = async () => {
    const response = await RoleService.RoleByID(this.state.viewId);

    if (response?.status && response.data) {
      this.setState({
        viewData: response.data,
      });
    }
  };

  viewPermissions = (permissions, constant = CONSTANT) => {
    if (!permissions) return "";

    const data = JSON.parse(permissions);
    let text = "";

    for (const property in data) {
      if (!data[property] || !constant[property]) continue;

      if (!text) text = constant[property];
      else text += ", " + constant[property];
    }

    return text;
  };

  render() {
    return (
      <div>
        <MainBreadcrumb
          routeSegments={[
            { name: "User Management", path: "#" },
            { name: "Roles", path: "/user-management/roles" },
            { name: "View" },
          ]}
          breadCrumbsText="User_Management_Roles"
        />
        {this.state.viewData && Object.keys(this.state.viewData).length > 0 && (
          <Fragment>
            <div className="row d-flex justify-content-center">
              <div className="col-md-12">
                <div className="card mt-4 mb-3">
                  <div className="card-body">
                    <div className="simple-card-title">
                      <h3 class="text-capitalize mb-1">View Role</h3>
                      <BackBtn url="/user-management/roles" />
                    </div>
                    <div
                      className="addressSmlSec"
                      style={{ paddinTop: "0", borderTop: "0" }}
                    >
                      <Row>
                        <Col md={3} className="drilingView-bx">
                          <h5>Role</h5>
                          <p>{this.state.viewData.title}</p>
                        </Col>
                        <Col md={3} className="drilingView-bx">
                          <h5>Level</h5>
                          <p>
                            {
                              USERROLE.find(
                                (role) =>
                                  role.value === this.state.viewData.roleLable
                              )?.name
                            }
                          </p>
                        </Col>
                        <Col md={3} className="drilingView-bx">
                          <h5>Site Type</h5>
                          <p>
                            {
                              SITETYPE.find(
                                (role) =>
                                  role.value === this.state.viewData.siteType
                              )?.name
                            }
                          </p>
                        </Col>
                        {/* <Col md={6} className="drilingView-bx">
                          <h5>Manage Permissions</h5>
                          <p>
                            {this.viewPermissions(
                              this.state.viewData.permissionNames
                            )}
                          </p>
                        </Col> */}
                        {/* <Col md={3} className="drilingView-bx">
                          <h5>Training Permissions</h5>
                          <p>
                            {this.viewPermissions(
                              this.state.viewData.ehsPermissions,
                              TRAINING_CONSTANT
                            )}
                          </p>
                        </Col>
                        <Col md={3} className="drilingView-bx">
                          <h5>Incident Permissions</h5>
                          <p>
                            {this.viewPermissions(
                              this.state.viewData.ehsPermissions,
                              INCIDENT_CONSTANT
                            )}
                          </p>
                        </Col>
                        <Col md={6} className="drilingView-bx">
                          <h5>Work Permit Permissions</h5>
                          <p>
                            {this.viewPermissions(
                              this.state.viewData.ehsPermissions,
                              WORKPERMIT_CONSTANT
                            )}
                          </p>
                        </Col> */}
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <LogHistory
              subModulename={"roles"}
              refrenceId={this.state.viewId}
            ></LogHistory>
          </Fragment>
        )}
      </div>
    );
  }
}

export default ViewRoles;
